import React from 'react';

interface BrowserFrameProps {
  url?: string;
  children: React.ReactNode;
  darkChrome?: boolean;
}

const BrowserFrame: React.FC<BrowserFrameProps> = ({ url = 'miid.app/dashboard', children, darkChrome = false }) => {
  const chromeBg = darkChrome ? '#0F2744' : '#F1F5F9';
  const chromeBorder = darkChrome ? 'rgba(255,255,255,.08)' : 'rgba(26,111,168,.14)';
  const urlBg = darkChrome ? 'rgba(255,255,255,.08)' : '#FFFFFF';
  const urlColor = darkChrome ? 'rgba(255,255,255,.55)' : '#2D5278';

  return (
    <div
      style={{
        width: '100%',
        background: 'var(--white)',
        border: `1px solid ${chromeBorder}`,
        borderRadius: '8px',
        overflow: 'hidden',
        boxShadow: '0 20px 60px -20px rgba(26,111,168,.25), 0 8px 20px -8px rgba(26,111,168,.15)',
      }}
    >
      {/* Chrome bar */}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '.8rem',
          padding: '.6rem .9rem',
          background: chromeBg,
          borderBottom: `1px solid ${chromeBorder}`,
        }}
      >
        {/* 3 dots */}
        <div style={{ display: 'flex', gap: '6px' }}>
          {['#FF5F57', '#FEBC2E', '#28C840'].map((c) => (
            <div key={c} style={{ width: '10px', height: '10px', borderRadius: '50%', background: c }} />
          ))}
        </div>
        {/* URL bar */}
        <div
          style={{
            flex: 1,
            padding: '.3rem .8rem',
            background: urlBg,
            borderRadius: '4px',
            fontFamily: "'Montserrat', sans-serif",
            fontSize: '.6rem',
            color: urlColor,
            letterSpacing: '.02em',
            display: 'flex',
            alignItems: 'center',
            gap: '.5rem',
          }}
        >
          <svg width="9" height="9" viewBox="0 0 12 12" fill="none">
            <path d="M9 5V4a3 3 0 00-6 0v1" stroke={urlColor} strokeWidth="1.2" />
            <rect x="2" y="5" width="8" height="6" rx="1" stroke={urlColor} strokeWidth="1.2" />
          </svg>
          {url}
        </div>
      </div>

      {/* Content */}
      <div style={{ padding: 0, background: 'var(--white)' }}>{children}</div>
    </div>
  );
};

export default BrowserFrame;
